import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVerificationProcessing = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "a",
	xmlns: "http://www.w3.org/2000/svg",
	width: 240,
	height: 200,
	viewBox: "0 0 240 200",
	...props,
	children: [
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("style", { children: ".b{fill-rule:evenodd;}" }) }),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M38.82,35.88c-3.31,0-6,2.69-6,6s2.69,6,6,6,6-2.69,6-6-2.69-6-6-6Zm0,9.36c-1.85,0-3.36-1.51-3.36-3.36s1.51-3.36,3.36-3.36,3.36,1.51,3.36,3.36-1.51,3.36-3.36,3.36Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M68.82,30.38c0-.83-.67-1.5-1.5-1.5s-1.5,.67-1.5,1.5,.67,1.5,1.5,1.5,1.5-.67,1.5-1.5Z"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 183.32,
			cy: 51.38,
			r: 2.5
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 202.5,
			cy: 131.5,
			r: 2.5
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M142.42,125.48h15.71c-7.45,12.91-21.38,21.6-37.31,21.6-20.09,0-36.99-13.82-41.8-32.4h-11.12c5.02,24.62,26.78,43.2,52.92,43.2,17.66,0,33.37-8.53,43.2-21.65v10.85h10.8v-32.4h-32.4v10.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M99.22,82.28h-15.71c7.45-12.91,21.38-21.6,37.31-21.6,20.09,0,36.99,13.82,41.8,32.4h11.12c-5.02-24.62-26.78-43.2-52.92-43.2-17.66,0-33.37,8.53-43.2,21.65v-10.85h-10.8v32.4h32.4v-10.8Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M71.46,151.35c-1.95,0-3.54,1.59-3.54,3.54s1.59,3.54,3.54,3.54,3.54-1.59,3.54-3.54-1.59-3.54-3.54-3.54Zm0,5.52c-1.09,0-1.98-.89-1.98-1.98s.89-1.98,1.98-1.98,1.98,.89,1.98,1.98-.89,1.98-1.98,1.98Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "b",
			d: "M175.83,98.45c-.83,0-1.5,.67-1.5,1.5s.67,1.5,1.5,1.5,1.5-.67,1.5-1.5-.67-1.5-1.5-1.5Z"
		})
	]
});
export default SvgVerificationProcessing;
